import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
export function ThankYouPage() {
  const {
    t
  } = useLanguage();
  return <div className="w-full min-h-screen bg-lightGray flex flex-col" data-id="element-226">
      <Navbar data-id="element-227" />

      <div className="flex-grow flex items-center justify-center px-4 py-16" data-id="element-228">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="max-w-2xl w-full bg-white rounded-lg shadow-2xl p-8 md:p-12 text-center" data-id="element-229">
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} data-id="element-230">
            <CheckCircle className="mx-auto text-green-500 mb-6" size={80} data-id="element-231" />
          </motion.div>

          <h1 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-232">
            {t('thanks.title')}
          </h1>

          <div className="w-16 h-1 bg-gold mx-auto mb-6" data-id="element-233"></div>

          <p className="text-lg text-gray-700 mb-6" data-id="element-234">{t('thanks.message')}</p>

          <div className="bg-lightGray p-6 rounded-lg mb-8" data-id="element-235">
            <p className="text-gray-700" data-id="element-236">
              <strong className="text-navy" data-id="element-237">
                {t('thanks.commitment.title')}
              </strong>{' '}
              {t('thanks.commitment.text')}
            </p>
          </div>

          <div className="space-y-4" data-id="element-238">
            <Link to="/" className="inline-block bg-gold text-navy px-8 py-3 rounded-md font-semibold hover:bg-opacity-90 transition-all shadow-lg" data-id="element-239">
              {t('thanks.backHome')}
            </Link>

            <p className="text-sm text-gray-500" data-id="element-240">
              {t('thanks.questions')} (954) 931-4833
            </p>
          </div>
        </motion.div>
      </div>

      <Footer data-id="element-241" />
    </div>;
}